/* eslint max-len: 0 */
import {SupportedLanguages} from '../../../../../../../types/SupportedLanguages';

const EMPION_HOME_PAGE = 'https://www.empion.io/';
const EMPION_EMAIL = 'info@empion.de ';

const germanText = (surveyLink: string, date: string): string => {
  return `
    <Grid>
      <p>Liebes Team,</p>
      <p>
        Um weiterhin für euch ein attraktiver Arbeitgeber sein zu können, uns zu verbessern und, weil wir von euch gerne
        ein Stimmungsbild zu unserer Unternehmenskultur einholen möchten, führen wir mit Empion (<a href="${EMPION_HOME_PAGE}">empion.io</a>) eine
        Kulturanalyse durch. Mit dem Empion Fragebogen erhalten wir ein umfangreiches Bild unserer Unternehmenskultur
        und ihr habt nun die Chance, durch eure Teilnahme direkt an der Veränderung mitzuwirken!
      </p>
      <p>
        Lasst uns gemeinsam unsere Kultur gestalten! Mit dem unten verlinkten Fragebogen teilt ihr uns mit, wie wir uns
        verbessern können und was wir bereits gut machen. Bitte nehmt euch die Zeit diesen Fragebogen auszufüllen, damit
        wir ein authentisches Bild bekommen. Eure Antworten und Daten bleiben selbstverständlich zu 100% anonym, werden
        vertraulich behandelt, und werden nicht weitergegeben.
      </p>
      <p>
        Es wäre großartig, wenn ihr euch als Teil unseres Unternehmens die Zeit nehmt und den Fragebogen bis zum 📅 <strong><u>${date}</u></strong>
        ausfüllt, damit wir uns so authentisch wie möglich präsentieren können. Unter diesem Link findet ihr den
        Fragebogen: ✅ <a href="${surveyLink}"><strong>Umfragelink</strong></a>
      </p>
      <p>
        Für Rückfragen stehen wir euch gerne zur Verfügung und das Team von Empion steht euch bei Anmerkungen oder
        Rückfragen unter <a href="mailto:${EMPION_EMAIL}">${EMPION_EMAIL}</a> ebenfalls mit Rat und Tat zur Seite.
      </p>
      <p>Vielen Dank für euer Bemühen!</p>
    </Grid>`;
};

const englishText = (surveyLink: string, date: string) => {
  return `
  <Grid>
    <p>Dear Team,</p>
    <p>
      In an effort to improve our company, and to remain an attractive employer for all our employees, we kindly ask
      that you take some time in the next week to fill out this culture analysis, provided by Empion (<a href="${EMPION_HOME_PAGE}">empion.io</a>).
      With this questionnaire, we hope to gain a comprehensive picture of our company culture. Your participation
      has the ability to effect change!
    </p>
    <p>
      Let's shape our culture together! Use the questionnaire linked below to tell us how we can improve and what we
      are already doing well. Please take the time to fill out this questionnaire so that we can get an authentic
      picture. Your answers and data will of course remain 100% anonymous, will be treated confidentially and will
      not be passed on.
    </p>
    <p>
      It would be great if you, as part of our company, took the time and filled out the questionnaire by 📅 <strong><u>${date}</u></strong>
      so that we can present ourselves as authentically as possible. You can find the questionnaire under
      this link: ✅ <a href="${surveyLink}"><strong>Survey link</strong></a>
    </p>
    <p>
      We are happy to answer any questions you may have and the Empion team is also available to provide you with
      advice and support if you have any comments or queries at <a href="mailto:${EMPION_EMAIL}">${EMPION_EMAIL}</a>.
    </p>
    <p>Thank you for your efforts!</p>
  </Grid>`;
};

export const getEmailTemplateText = (lang: SupportedLanguages, surveyLink: string, date: string) =>
  lang === 'de' ? germanText(surveyLink, date) : englishText(surveyLink, date);
